let localStorageKeySummary = 'order-summary';

function cn_get_summary( change = false ) {
    // let page_id = document.querySelector('input[name^="gform_source_page_number_"]').value;
    // page_id = parseInt(page_id);

    let storage = localStorage.getItem(localStorageKeySummary);

    if( ! change && storage ) {
        return JSON.parse(storage);
    }

    /**
     * The total price of the selected items
     * @type {string}
     */
    let price = 0;

    /**
     * Get all visible items and show them in an overview
     * @type {NodeListOf<Element>}
     */
    let choices = document.querySelectorAll('[class*="cn-choice"][data-conditional-logic="visible"], [class*="cn-choice"]:not([data-conditional-logic])');

    /**
     * Loop through all items and add the value to the overview
     */
    let overview = [];
    choices.forEach(function(choice) {
        /**
         * Get the input element
         * @type {Element}
         */
        let input = choice.querySelector('input:checked, input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], input[type="time"], input[type="url"], input[type="file"], textarea, select');

        if (input) {
            let label = choice.querySelector('.gfield_label').innerHTML;
            label = label.replace(/<span class="gfield_required">.*<\/span>/, '');

            let value = input.value.split('|') ? input.value.split('|')[0] : input.value;
            let costs = 0;

            if (input.value.split('|')) {
                let split = input.value.split('|');
                value = split[0];
                costs = parseFloat(split[1]);

                if (costs > 0 && false === choice.classList.contains('cn-monthly')) {
                    price = price + costs;
                }
            }

            let extra_label = choice.querySelector('label');
            if( extra_label ) {
                let data_label = extra_label.getAttribute('data-label');
                if( data_label ) {
                    label = data_label;
                }
            }

            /**
             * Cover the costs to 2 decimals
             * @type {number}
             */
            costs = costs ? costs : 0;
            costs = costs.toFixed(2);

            /**
             * Capitalize the first letter of the value
             * @type {string}
             */
            value = value.charAt(0).toUpperCase() + value.slice(1);

            /**
             * Return the label, value and costs
             * @type {{label: string, value: string, costs: number}}
             */
            overview.push({
                label: label,
                value: value,
                costs: costs,
                monthly: true === choice.classList.contains('cn-monthly')
            });
        }
    });

    /**
     * Get the price of the selected subscription
     * @type {NodeListOf<Element>}
     */
    let selected_subscription = document.querySelectorAll('.cn-subscription--block[data-conditional-logic="visible"]');
    let subscription = {};
    if( selected_subscription ) {
        selected_subscription.forEach(function(product) {
            let parent = product;

            /**
             * Check if the parent is visible
             * @type {Element}
             */
            //if( parent.style.display === 'block' ) {
                let subscription_title = parent.querySelector('.cn-subscription--title').innerHTML;
                let subscription_price = parent.querySelector('.cn-subscription--price');

                /**
                 * Check if the parent is visible
                 */
                if( subscription_title) {
                    if( subscription_price ) {
                        subscription_price = subscription_price.innerHTML.match(/\d+[\.,]?\d*/g);
                        subscription_price = subscription_price.length > 0 ? subscription_price[0].replace(',', '.') : 0;
                        subscription_price = parseFloat(subscription_price);
                    }

                    subscription_price = subscription_price ? subscription_price : 0.00;

                    overview.push({
                        label: 'Laadpaalbeheer',
                        value: subscription_title,
                        costs: subscription_price,
                        monthly: true
                    });

                    subscription = {
                        title: subscription_title,
                        price: subscription_price,
                        monthly: true
                    };
                }
            //}
        });
    }

    price = price.toFixed(2);
    price = price.replace('.', ',');
    price = price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    let fixed_fields = [];
    fixed_fields.push({
        label: 'Totaal eenmalig',
        costs: price,
    });

    let monthly_costs_fields =  overview.filter(function(item) {
        return item.monthly === true && parseFloat(item.costs) > 0;
    });

    let monthly_costs = 0;
    monthly_costs_fields.forEach(function(item) {
        monthly_costs += parseFloat(item.costs);
    });

    if( monthly_costs > 0 ) {
        fixed_fields.push({
            label: 'Maandelijkse kosten',
            costs: monthly_costs.toFixed(2),
        });
    }

    monthly_costs = monthly_costs.toFixed(2);
    monthly_costs = monthly_costs.replace('.', ',');
    monthly_costs = monthly_costs.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    document.querySelector('.cn-cost--total input').value = price;


    let selected_product = document.querySelector('.cn-image[data-conditional-logic="visible"] input:checked + label > img');
    let imageUrl = selected_product ? selected_product.src : null;

    if( imageUrl === null ) {
        let selected_product = document.querySelector('.cn-product--image input:checked');

        if( selected_product ) {
            let parent = selected_product.closest('.gchoice');
            let image = parent.querySelector('img');

            imageUrl = image.src;
        }
    }

    // let imageUrl = null;
    // let selected_product = document.querySelector('.cn-product input:checked');
    //
    // if( selected_product ) {
    //     let parent = selected_product.closest('.ginput_container');
    //     console.log(selected_product);
    //     let image = parent.querySelector('img');
    //
    //     imageUrl = image.src;
    // }

    overview = overview.map(function(item) {
        if( item.costs > 0 ) {
            item.costs  = parseFloat(item.costs);
            item.costs  = item.costs.toFixed(2);
            item.costs  = item.costs.replace('.', ',');
            item.costs  = item.costs.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }

        return item;
    });

    fixed_fields = fixed_fields.map(function(item) {
        if( item.costs > 0 ) {
            item.costs  = parseFloat(item.costs);
            item.costs  = item.costs.toFixed(2);
            item.costs  = item.costs.replace('.', ',');
            item.costs  = item.costs.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }

        return item;
    });

    /**
     * Build the data object
     * @type {{overview: *[], total_price: string }}
     */
    let data = { overview, fixed_fields, subscription, monthly_costs, total_price: price,  image: imageUrl };

    /**
     * Save the data in the local storage
     */
    localStorage.setItem(localStorageKeySummary, JSON.stringify(data));

    /**
     * Return the data
     */
    return data;
}




function cn_get_customer() {

    let customer = [];
    let groups = document.querySelectorAll('[class*="cn-field-group--"]');
    groups.forEach(function(field) {
        let groupName = field.className.match(/cn-field-group--\w+/g);
        if( groupName ) {
            groupName = groupName[0];
            groupName = groupName.replace('cn-field-group--', '');


            let label = field.querySelector('.gfield_label').innerHTML;
            label = label.replace(/<span class="gfield_required">.*<\/span>/, '');

            let valueField = field.querySelector('input:checked, input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], input[type="time"], input[type="url"], input[type="file"], textarea, select');

            if( valueField ) {
                let value = valueField.value;

                if (!customer[groupName]) {
                    customer[groupName] = [];
                }

                if (value.length > 0) {
                    customer[groupName].push({
                        label: label,
                        value: value
                    });
                }
            }
        }
    });

    return customer;
}

function cn_render_summary() {
    let page_id = document.querySelector('input[name^="gform_source_page_number_"]');
    if( ! page_id ) {
        return;
    }

    page_id = page_id.value;
    page_id = parseInt(page_id);

    if( page_id >= 4 ) {
        return;
    }


    // Add .cn-summary to .site-main
    let container = document.querySelector('.site-main');
    if( ! container ) {
        return;
    }

    let selectionView = document.querySelector('.cn-summary');
    if( ! selectionView ) {
        let customElement = document.createElement('div');
        selectionView = customElement;
        customElement.classList.add('cn-summary');

        container.appendChild(customElement);
    }

    // let selectionView = document.querySelector('.cn-summary');
    // if( ! selectionView ) {
    //     let customElement = document.createElement('div');
    //     selectionView = customElement;
    //     customElement.classList.add('cn-summary');
    //
    //     document.querySelector('.gform_body').appendChild(customElement);
    // }

    // onclick .cn-summary--header
    let openOrClose = document.querySelector('.cn-summary--open');

    let { fixed_fields, overview,  subscription } = cn_get_summary();

    let html = '';
    html += `<div class="cn-summary--header">`;
    html += `<div class="cn-summary--title">
        <span>${openOrClose ? 'Verberg details' : 'Toon details'}</span>
        <svg class="ast-arrow-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26px" height="16.043px" viewBox="57 35.171 26 16.043"  xml:space="preserve">
            <path d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"></path>
        </svg>
    </div>`;

    fixed_fields.forEach(function(field) {
        html += `<div class="cn-row">`;
        html += `<span>${field.label}</span>`;
        html += `<b>€ ${field.costs}</b>`;
        html += `</div>`;
    });

    html += `<div class="cn-row">`;
    html += `<small>(Alle bedragen zijn incl. BTW)</small>`;
    html += `</div>`;

    html += `</div>`;
    html += `<ul>`;

    overview.forEach(function(item) {
        html += `<li>`;
        html += `<b>${item.label}</b>`;
        html += `<div class="cn-row"><span>${item.value}</span>`;

        // check if costs is more than 0 or if item. cost is a string
        if( item.costs > 0 || isNaN(item.costs) ) {
            html += `<b>€ ${item.costs}`;

            if( item.monthly ) {
                html += ` /mnd`;
            }

            html += `</b>`;
        }

        html += `</div>`;
    });

    html += `</ul>`;

    selectionView.innerHTML = html;

    let header = document.querySelector('.cn-summary--header');
    let span = document.querySelector('.cn-summary--title span');

    header.addEventListener('click', function() {
        selectionView.classList.toggle('cn-summary--open');
        span.innerHTML = document.querySelector('.cn-summary').classList.contains('cn-summary--open') ? 'Verberg details' : 'Toon details';
    });
}

function cn_render_overview() {
    let { overview, total_price, fixed_fields, image } = cn_get_summary();
    let product_html = '';

    product_html = `<ul>`;
    overview.forEach(function(item) {
        product_html += `<li>`;
        product_html += `<b>${item.label}</b>`;
        product_html += `<div class="cn-row"><span>${item.value}</span>`;
        product_html += `<b>€ ${item.costs}</b>`;
        product_html += `</div>`;
        product_html += `</li>`;
    });
    product_html += `</ul>`;

    product_html += `<div class="cn-overview--details">`;
    fixed_fields.forEach(function(field) {
        product_html += `<div class="cn-row">`;
        product_html += `<span>${field.label}</span>`;
        product_html += `<b>&euro; ${field.costs}</b>`;
        product_html += `</div>`;
    });

    product_html += `<div class="cn-row">`;
    product_html += `<small>(Alle bedragen zijn incl. BTW)</small>`;
    product_html += `</div>`;

    product_html += `</div>`;
    document.querySelector('#cn-overview--response-product').innerHTML = product_html;

    const data = cn_get_customer();
    let loop = Object.keys(data);
    loop.forEach(function(key) {
        let customer = '';
        customer = `<ul>`;
        data[key].forEach(function(item) {
            customer += `<li>`;
            customer += `<b>${item.label}</b>`;
            customer += `<span>${item.value}</span>`;
            customer += `</li>`;
        });

        customer += `</ul>`;

        let response = document.querySelector(`#cn-overview--response-${key}`);

        if( response ) {
            response.innerHTML = customer;
        }
    });

    if( image ) {
        let img = document.createElement('img');
        img.src = image;
        document.querySelector('.cn-image--selected').appendChild(img);
    }
}

/**
 * When the input changes, calculate the price and show the overview
 */
gform.addAction( 'gform_input_change', function( elem, formId, fieldId )
{
    const dependentFieldIds = rgars(gf_form_conditional_logic, [formId, 'fields', gformExtractFieldId(fieldId)].join('/'));
    if( dependentFieldIds ) {
        gf_apply_rules( formId, dependentFieldIds );
    }

    let element = jQuery( elem );
    let field = element.closest('.gfield');
    let fieldClass = field.attr('class');

    if( fieldClass.includes('cn-choice') ) {
        setColorImage(element);
    }

    cn_get_summary( true );
    cn_render_summary();
}, 10, 3 );

jQuery(document).on('gform_post_render', function(event, form_id, current_page)
{
    if (current_page == 4) {
        cn_render_overview();
    } else {
        cn_render_summary();
    }
});





// function setColor (elem, color) {
//     if( elem ) {
//         // remove all cn-color--selected
//         let colors = document.querySelectorAll('.cn-color');
//         colors.forEach(function (color) {
//             color.classList.remove('cn-color--selected');
//         });
//
//         elem.classList.add('cn-color--selected');
//     }
//
//     let productLabel = document.querySelectorAll('.gform-product--label');
//     productLabel.forEach(function(label) {
//         if( label.innerHTML === color) {
//             let parent = label.closest('.gform-field-label');
//             let img = parent.querySelector('img');
//
//             let input = document.querySelector(`input[value="${color}"]`);
//             input.checked = true;
//
//             // send change event
//             let event = new Event('change');
//             input.dispatchEvent(event);
//
//             gf_raw_input_change( event, input );
//
//             let search = document.querySelector('.cn-product--name input:checked');
//             let parentChecked = search.closest('.gchoice');
//
//             parentChecked.querySelector('img').src = img.src;
//
//             cn_render_summary();
//         }
//     });
// }

function setColorImage (elem) {
    let selected_product = document.querySelector('.cn-color[data-conditional-logic="visible"] input:checked');
    if( selected_product ) {
        let parent = selected_product.closest('.gchoice');
        let attachments = parent.querySelectorAll('input[name^="attachment_url_image"]').length;

        for (let i = 1; i <= attachments; i++) {
            let attachment_url = parent.querySelector(`input[name="attachment_url_image_${i}"]`);
            if( attachment_url ) {
                let images = document.querySelectorAll(`.cn-product--image-${i} .gchoice:nth-child(${i}) img`);
                images.forEach(function (img) {
                    img.src = attachment_url.value;
                });
            }
        }

        //
        // console.log(attachments);
        //
        // /**
        //  * Get the URL
        //  */
        // let attachment_url = parent.querySelector('input[name="attachment_url_image_1"]');
        //
        // if( attachment_url ) {
        //     let images = document.querySelectorAll('.cn-product--image-1 .gchoice:nth-child(1) img');
        //     images.forEach(function (img) {
        //         img.src = attachment_url.value;
        //     });
        // }
        //
        // attachment_url = parent.querySelector('input[name="attachment_url_image_2"]');
        //
        // if( attachment_url ) {
        //     let images = document.querySelectorAll('.cn-product--image-2 .gchoice:nth-child(2) img');
        //     images.forEach(function (img) {
        //         img.src = attachment_url.value;
        //     });
        // }

        // /**
        //  * Search for the current image
        //  */
        // let parent = selected_product.closest('.gchoice');
        // let current_image = parent.querySelector('img');
        //
        //
        // /**
        //  * Get all valid images and store them in an array
        //  * @type {NodeListOf<Element>}
        //  */
        // let validImagesEl = document.querySelectorAll('.cn-color img');
        // let validImages = [];
        // validImagesEl.forEach(function (img) {
        //     validImages.push(img.src);
        // });
        //
        // /**
        //  * Get all images
        //  * @type {NodeListOf<Element>}
        //  */
        // let images = document.querySelectorAll('.cn-product--image .gchoice img');
        //
        // /**
        //  * Loop through all images and set the current image
        //  */
        // images.forEach(function (img) {
        //     if( validImages.includes(img.src) ) {
        //         img.src = current_image.src;
        //     }
        // });
    }
}


// onclick cn-contact
document.addEventListener('click', function(event) {
    let element = event.target;
    if( element.classList.contains('cn-contact') ) {
        let submitButton = document.querySelector('.cn-contact-action input');
        if (submitButton) {
            submitButton.value = 'contact';
            document.querySelector('.gform_button').click();
        }
    }
});